<template>
  <b-row>
    <b-col md="6">
      <template v-if="plan.id">

        <div>
          Libelle:
          <span class="textTeal">{{ plan.name }}</span>
        </div>

        <div>
          Debut de mon abonement:
          <span class="textTeal">{{ plan.created_at }}</span>
        </div>

        <div>
          Date du prochain prelevement:
          <span class="textTeal">{{ plan.ends_at }}</span>
        </div>

        <div>
          Prix de mon abonnement:
          <span class="textTeal">{{ plan.price }}</span>
        </div>

        <div>
          Statut de mon abonnement:
          <div class="inline-block textTeal">{{ plan.status }}</div>
        </div>
      </template>
      <a :href="home_url+'/offers'" class="btn btn-primary" v-else>Prendre un abonnement</a>
    </b-col>
    <b-col md="6">
      <div class="my-2 d-flex justify-content-md-end justify-content-start">
        <b-button :to="{name:'payments'}" squared variant="outline-secondary"
                  class="d-flex justify-content-between align-items-center text-left w-75">
          Historique de mes paiements
          <b-icon icon="chevron-right" aria-hidden="true" class="icon"></b-icon>
        </b-button>
      </div>
      <div class="my-2 d-flex justify-content-md-end justify-content-start">
        <b-button :to="{name:'subscriptions'}" squared variant="outline-secondary"
                  class="d-flex justify-content-between align-items-center text-left w-75">
          Historique de mes abonnements
          <b-icon icon="chevron-right" aria-hidden="true" class="icon"></b-icon>
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['user', 'home_url']),
    plan() {
      return {}
    }
  }
};
</script>
<style scoped>
.containerButtons {
  min-width: 30%;
}

button {
  margin-bottom: 10px;
}

.icon {
  height: 25px;
  color: teal;
}

.textTeal {
  color: teal;
}
</style>
